export const HAPPY_RETURNS_APPLE_WALLET_BADGE_URL =
  "https://assets.getredo.com/happy-returns/add-to-apple-wallet.svg";

export const HAPPY_RETURNS_GOOGLE_WALLET_BADGE_URL =
  "https://assets.getredo.com/happy-returns/add-to-google-wallet.svg";
